import React from 'react'
import './landing.scss'
import Slider from 'infinite-react-carousel';
import mutant1 from '../images/backgrounds/b1.png'
// import mutant1 from '../images/mutant1.jpeg'

import SplitMenu from './SplitMenu'; 
import osLogo2 from '../images/opensea_2.png'

function OpenSeaDial(){
  return(
      <div class='flex pt-8'>

<div onClick={() => window.open('https://opensea.io/sleepy-house-keys')} class='bg-sky-700 hover:pr-8 duration-150 mx-auto rounded-full  text-[0px] hover:text-base cursor-pointer'>
<img  class='mx-auto h-16   inline-block  ' src={osLogo2}></img>
<h1 class='inline-block'>View On Opensea</h1>
</div>
</div>
  )
}

const SimpleSlider = () => (
    <div >

    <Slider slidesToShow={3} centerMode={true} dots>
      <div>
       <img  class='  max-w-lg  max-h-64 rounded-xl ' src={mutant1}></img>
      </div>
      <div>
      <img  class='  max-w-lg  max-h-64 rounded-xl ' src={mutant1}></img>      </div>
      <div>
      <img  class='  max-w-lg  max-h-64  rounded-xl ' src={mutant1}></img>      </div>
      <div>
      <img  class='  max-w-lg  max-h-64 rounded-xl ' src={mutant1}></img>      </div>
      <div>
      <img  class='  max-w-lg  max-h-64  rounded-xl ' src={mutant1}></img>      </div>
    </Slider>
    </div>
  );

const CenterGrid = () =>{
  const hoverState = 'hover-class'
  return(
    <>
    <div class='flex  mt-[5vh]'>
    
    <div class='grid grid-cols-1 md:grid-cols-1 bg-[rgba(255,255,255,.5)] mx-auto text-4xl rounded-lg   ${hoverState} gap-4'>
<div class={`bg-[rgba(255,255,255,.3)] rounded-lg`} ><div class={`${hoverState}  w-[100%]  rounded-lg `} >Discord</div></div>
      <div                                          class={`${hoverState}  px-3`}>Instagram</div>
      <div class={`bg-[rgba(255,255,255,.3)] rounded-lg`} ><div class={`${hoverState}  w-[100%]  rounded-lg `} >Medium</div></div>
      <div                                            class={`${hoverState} px-3`}>Twitter</div>
      <div class={`bg-[rgba(255,255,255,.3)] rounded-lg ${hoverState} px-3 `}>Whitepaper</div>
      <div                                            class={`${hoverState} px-3`}>OpenSea</div>

    </div>
    </div>
    
    </>
  )
}
const Landing = () => {
  return (
      <>
    <div class='bg-image'></div>

    <div class='flex flex-col text-center pt-8' >
        <h1 class='text-3xl font-bold'>Sleepy Portal</h1>

        <h1><br></br></h1>
        
    {/* <CenterGrid/> */}
    </div>

    {/* <SimpleSlider/> */}
    </>
    
  )
}

export default Landing